import { FirearmStorageLocationPLI } from 'assets-model';
import { FirearmStorageLocationResolver } from 'assets-service';
import { FirearmStorageLocationPLIEditorComponent } from './domain/firearm_storage_location/editor/firearm-storage-location-pli-editor.component';
import { FirearmStorageLocationPLIItemComponent } from './domain/firearm_storage_location/editor/firearm-storage-location-pli-item.component';
import { FirearmStorageLocationPLISearchComponent } from './domain/firearm_storage_location/search/firearm-storage-location-pli-search.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CacheListComponent, CrudCanDeactivate, CrudEditConfig, DataSourceAdminServiceListComponent, InternalFileSearchComponent, LogoutComponent, ManualJobComponent, ReportRunComponent, Role, ScheduledServiceListComponent, User, UserSessionAdminServiceListComponent } from '@scisys-uim/uim-common';
import { AmmunitionStock, Asset, AssetMaintenance, AssetsUserDetails, AssetType, BusinessUnit, BusinessUnitAddress, BusinessUnitEmailContact, CostCentre, Firearm, FirearmAssignment, FirearmAssignmentLog, FirearmPool, FirearmStorageLocation, Ranger, RangerFirearmAssignmentLog, RefCode, RefCodeKey, TransferAsset } from 'assets-model';
import { AmmunitionStockEditorComponent } from './domain/ammunition_stock/editor/ammunition-stock-editor.component';
import { AmmunitionStockEventRowsEditorComponent } from './domain/ammunition_stock/editor/ammunition-stock-event-rows-editor.component';
import { AmmunitionStockEventRowsComponent, AmmunitionStockEventRowsEditConfig } from './domain/ammunition_stock/editor/ammunition-stock-event-rows.component';
import { AmmunitionStockItemComponent } from './domain/ammunition_stock/editor/ammunition-stock-item.component';
import { AmmunitionStockEventHistoryComponent } from './domain/ammunition_stock/search/ammunition-stock-event-search.component';
import { AmmunitionStockSearchComponent } from './domain/ammunition_stock/search/ammunition-stock-search.component';
import { AssetAuditListComponent } from './domain/asset/audit/asset-audit-list.component';
import { AssetEditorComponent } from './domain/asset/editor/asset-editor.component';
import { AssetItemComponent } from './domain/asset/editor/asset-item.component';
import { AssetSearchComponent } from './domain/asset/search/asset-search.component';
import { AssetMaintenanceEditorComponent } from './domain/assetmaintenance/editor/asset-maintenance-editor.component';
import { AssetMaintenanceItemComponent } from './domain/assetmaintenance/editor/asset-maintenance-item.component';
import { AssetMaintenanceSearchComponent } from './domain/assetmaintenance/search/asset-maintenance-search.component';
import { AssetTypeEditorComponent } from './domain/assettype/editor/asset-type-editor.component';
import { AssetTypeItemComponent } from './domain/assettype/editor/asset-type-item.component';
import { AssetTypeSearchComponent } from './domain/assettype/search/asset-type-search.component';
import { BusinessUnitAddressEditorComponent } from './domain/businessunit/editor/business-unit-address-editor.component';
import { BusinessUnitAddressItemComponent } from './domain/businessunit/editor/business-unit-address-item.component';
import { BusinessUnitEditorComponent } from './domain/businessunit/editor/business-unit-editor.component';
import { BusinessUnitEmailContactEditorComponent } from './domain/businessunit/editor/business-unit-email-contact-editor.component';
import { BusinessUnitEmailContactItemComponent } from './domain/businessunit/editor/business-unit-email-contact-item.component';
import { BusinessUnitItemComponent } from './domain/businessunit/editor/business-unit-item.component';
import { BusinessUnitAddressSearchComponent } from './domain/businessunit/search/business-unit-address-search.component';
import { BusinessUnitEmailContactSearchComponent } from './domain/businessunit/search/business-unit-email-contact-search.component';
import { BusinessUnitSearchComponent } from './domain/businessunit/search/business-unit-search.component';
import { CostCentreEditorComponent } from './domain/costcentre/editor/cost-centre-editor.component';
import { CostCentreItemComponent } from './domain/costcentre/editor/cost-centre-item.component';
import { CostCentreSearchComponent } from './domain/costcentre/search/cost-centre-search.component';
import { TransferReminderEmailTemplatesComponent } from './domain/email-templates/assets/transfer-reminder/transfer-reminder-email-templates.component';
import { FirearmAssignmentIssuePoliceNotifyEmailTemplatesComponent } from './domain/email-templates/firearms/notify-police-issue/firearm-assignment-issue-police-notify-email-template.component';
import { FirearmAssignmentStorageAcquirePoliceNotifyEmailTemplatesComponent } from './domain/email-templates/firearms/notify-police-storage/firearm-assignment-storage-acquire-police-notify-email-template.component';
import { FirearmAssignmentStorageDisposePoliceNotifyEmailTemplatesComponent } from './domain/email-templates/firearms/notify-police-storage/firearm-assignment-storage-dispose-police-notify-email-template.component';
import { FirearmAssignmentStorageReturnPoliceNotifyEmailTemplatesComponent } from './domain/email-templates/firearms/notify-police-storage/firearm-assignment-storage-return-police-notify-email-template.component';
import { FirearmAssignmentStorageTransferPoliceNotifyEmailTemplatesComponent } from './domain/email-templates/firearms/notify-police-storage/firearm-assignment-storage-transfer-police-notify-email-template.component';
import { FirearmAuditListComponent } from './domain/firearm/audit/firearm-audit-list.component';
import { FirearmEditorComponent } from './domain/firearm/editor/firearm-editor.component';
import { FirearmItemComponent } from './domain/firearm/editor/firearm-item.component';
import { FirearmSearchComponent } from './domain/firearm/search/firearm-search.component';
import { FirearmAssignmentEditorComponent } from './domain/firearm_assignment/editor/firearm-assignment-editor.component';
import { FirearmAssignmentItemComponent } from './domain/firearm_assignment/editor/firearm-assignment-item.component';
import { FirearmAssignmentLogEditorComponent } from './domain/firearm_assignment/editor/firearm-assignment-log-editor.component';
import { FirearmAssignmentLogItemComponent } from './domain/firearm_assignment/editor/firearm-assignment-log-item.component';
import { FirearmAssignmentSearchComponent } from './domain/firearm_assignment/search/firearm-assignment-search.component';
import { FirearmPoolEditorComponent } from './domain/firearm_pool/editor/firearm-pool-editor.component';
import { FirearmPoolItemComponent } from './domain/firearm_pool/editor/firearm-pool-item.component';
import { FirearmPoolSearchComponent } from './domain/firearm_pool/search/firearm-pool-search.component';
import { FirearmStorageLocationEditorComponent } from './domain/firearm_storage_location/editor/firearm-storage-location-editor.component';
import { FirearmStorageLocationItemComponent } from './domain/firearm_storage_location/editor/firearm-storage-location-item.component';
import { FirearmStorageLocationSearchComponent } from './domain/firearm_storage_location/search/firearm-storage-location-search.component';
import { RangerAcknowledgeAssignmentComponent } from './domain/ranger/acknowledge-assignment/acknowledge-assignment.component';
import { RangerEditorComponent } from './domain/ranger/editor/ranger-editor.component';
import { RangerItemComponent } from './domain/ranger/editor/ranger-item.component';
import { RangerSearchComponent } from './domain/ranger/search/ranger-search.component';
import { RangerFirearmAssignmentLogEditorComponent } from './domain/ranger_firearm_assignment/editor/ranger-firearm-assignment-log-editor.component';
import { RangerFirearmAssignmentLogItemComponent } from './domain/ranger_firearm_assignment/editor/ranger-firearm-assignment-log-item.component';
import { RefCodeEditorComponent } from './domain/refcode/editor/ref-code-editor.component';
import { RefCodeItemComponent } from './domain/refcode/editor/ref-code-item.component';
import { RefCodeSearchComponent } from './domain/refcode/search/ref-code-search.component';
import { RoleEditorComponent } from './domain/role/editor/role-editor.component';
import { RoleItemComponent } from './domain/role/editor/role-item.component';
import { RoleSearchComponent } from './domain/role/search/role-search.component';
import { TransferAssetEditorComponent } from './domain/transferasset/editor/transfer-asset-editor.component';
import { TransferAssetItemComponent } from './domain/transferasset/editor/transfer-asset-item.component';
import { UserEditorComponent } from './domain/user/editor/user-editor.component';
import { UserItemComponent } from './domain/user/editor/user-item.component';
import { UserSearchComponent } from './domain/user/search/user-search.component';
import { AssetsUserDetailsEditorComponent } from './domain/userdetails/editor/assets-user-details-editor.component';
import { AssetsUserDetailsItemComponent } from './domain/userdetails/editor/assets-user-details-item.component';
import { ServerErrorComponent } from './pages/error/server-error.component';
import { UnauthorisedErrorComponent } from './pages/error/unauthorised-error.component';
import { HomeComponent } from './pages/home/home.component';
import { AdminLandingPageComponent } from './pages/landing/admin/landing-page.component';
import { AssetsLandingPageComponent } from './pages/landing/assets/landing-page.component';
import { FirearmsLandingPageComponent } from './pages/landing/firearms/landing-page.component';
import { LandingPageComponent, LandingPageConfig } from './pages/landing/landing-page.component';
import { LoginComponent } from './pages/login/login.component';
import { AssetDataUploadComponent } from './domain/asset/upload/asset-data-upload.component';
import { FirearmDataUploadComponent } from './domain/firearm/upload/firearm-data-upload.component';
import { RangerAmmunitionIssueEmailTemplatesComponent } from './domain/email-templates/ammunition/ranger-issue/ranger-ammunition-issue-email-template.component';
import { AmmunitionAcknowledgeIssueReturnComponent } from './domain/ammunition_stock/acknowledge-issue-return/acknowledge-issue-return.component';
import { FirearmMaintenanceNotificationEmailTemplatesComponent } from './domain/email-templates/firearms/maintenance-notification/firearm-maintenance-notification-email-template.component';


// fix for when running AOT builds (like production or i18n) - cannot use functions/const in decorator:
// The error says only for non-exported const/function, but in practise this makes no difference.
// see link for alternatives, which might be needed if we combine module routes.
// https://medium.com/angular-in-depth/solving-aot-error-in-ngrx-function-calls-are-not-supported-in-decorators-5c337381457a
export function defaultCurrentDate() { return new Date(); };

export const _moduleRootsVal: Routes = [
  {
    path: '',
    component: HomeComponent,
    data: {
      parentMenuLink: '/home',
    }
  },
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'unauthorised',
    component: UnauthorisedErrorComponent
  },
  {
    path: 'serverError',
    component: ServerErrorComponent
  },
  {
    path: 'systemadmin/caches',
    component: CacheListComponent
  },
  {
    path: 'systemadmin/scheduled-services',
    component: ScheduledServiceListComponent
  },
  {
    path: 'systemadmin/datasource-admin-services',
    component: DataSourceAdminServiceListComponent
  },
  {
    path: 'systemadmin/user-session-admin-services',
    component: UserSessionAdminServiceListComponent
  },
  {
    path: 'manualjobs',
    component: ManualJobComponent,
    data: {
      parentMenuLink: '/admin',
    }
  },
  {
    path: 'admin',
    component: LandingPageComponent,
    data: <LandingPageConfig>{
      componentType: AdminLandingPageComponent
    }
  },
  {
    path: 'systemadmin/caches',
    component: CacheListComponent
  },
  {
    path: 'systemadmin/scheduled-services',
    component: ScheduledServiceListComponent
  },
  {
    path: 'systemadmin/datasource-admin-services',
    component: DataSourceAdminServiceListComponent
  },
  {
    path: 'systemadmin/user-session-admin-services',
    component: UserSessionAdminServiceListComponent
  },

  //routes for email templates 
  {
    path: 'email-templates/assets/transfer-reminder',
    component: LandingPageComponent,
    data: <LandingPageConfig>{
      parentMenuLink: '/admin',
      componentType: TransferReminderEmailTemplatesComponent
    }
  },
  {
    path: 'email-templates/firearms/police-notify/issue',
    component: LandingPageComponent,
    data: <LandingPageConfig>{
      parentMenuLink: '/admin',
      componentType: FirearmAssignmentIssuePoliceNotifyEmailTemplatesComponent
    }
  },
  {
    path: 'email-templates/firearms/police-notify/storage-acquire',
    component: LandingPageComponent,
    data: <LandingPageConfig>{
      parentMenuLink: '/admin',
      componentType: FirearmAssignmentStorageAcquirePoliceNotifyEmailTemplatesComponent
    }
  },
  {
    path: 'email-templates/firearms/police-notify/storage-return',
    component: LandingPageComponent,
    data: <LandingPageConfig>{
      parentMenuLink: '/admin',
      componentType: FirearmAssignmentStorageReturnPoliceNotifyEmailTemplatesComponent
    }
  },
  {
    path: 'email-templates/firearms/police-notify/storage-transfer',
    component: LandingPageComponent,
    data: <LandingPageConfig>{
      parentMenuLink: '/admin',
      componentType: FirearmAssignmentStorageTransferPoliceNotifyEmailTemplatesComponent
    }
  },
  {
    path: 'email-templates/firearms/maintenance/notification',
    component: LandingPageComponent,
    data: <LandingPageConfig>{
      parentMenuLink: '/admin',
      componentType: FirearmMaintenanceNotificationEmailTemplatesComponent
    }
  },
  {
    path: 'email-templates/firearms/police-notify/storage-dispose',
    component: LandingPageComponent,
    data: <LandingPageConfig>{
      parentMenuLink: '/admin',
      componentType: FirearmAssignmentStorageDisposePoliceNotifyEmailTemplatesComponent
    }
  },
  {
    path: 'email-templates/ammunition/ranger-issue',
    component: LandingPageComponent,
    data: <LandingPageConfig>{
      parentMenuLink: '/admin',
      componentType: RangerAmmunitionIssueEmailTemplatesComponent
    }
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: 'report-run',
    component: ReportRunComponent
  },
  {
    path: 'report-run/:selectedReport',
    component: ReportRunComponent
  },
  {
    path: 'assets',
    component: LandingPageComponent,
    data: <LandingPageConfig>{
      componentType: AssetsLandingPageComponent
    }
  },
  {
    path: 'firearms',
    component: LandingPageComponent,
    data: <LandingPageConfig>{
      componentType: FirearmsLandingPageComponent
    }
  },
  // routes for RefCode

  {
    path: 'refcode/search',
    component: RefCodeSearchComponent,
    data: {
      parentMenuLink: '/admin'
    }
  },
  {
    path: 'refcode/create',
    component: RefCodeEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<RefCode, RefCodeKey>>{
      parentMenuLink: '/admin',
      itemComponentType: RefCodeItemComponent
    }
  },
  {
    path: 'refcode/edit/:code/:domain',
    component: RefCodeEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<RefCode, RefCodeKey>>{
      parentMenuLink: '/admin',
      itemComponentType: RefCodeItemComponent
    }
  },
  {
    path: 'refcode/view/:code/:domain',
    component: RefCodeEditorComponent,
    data: <CrudEditConfig<RefCode, RefCodeKey>>{
      parentMenuLink: '/admin',
      itemComponentType: RefCodeItemComponent,
      readOnly: true
    }
  },


  // routes for BusinessUnit

  {
    path: 'businessunit/search',
    component: BusinessUnitSearchComponent,
    data: {
      parentMenuLink: '/admin'
    }
  },
  {
    path: 'businessunit/create',
    component: BusinessUnitEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<BusinessUnit, string>>{
      parentMenuLink: '/admin',
      itemComponentType: BusinessUnitItemComponent
    }
  },
  {
    path: 'businessunit/edit/:buId',
    component: BusinessUnitEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<BusinessUnit, string>>{
      parentMenuLink: '/admin',
      itemComponentType: BusinessUnitItemComponent
    }
  },
  {
    path: 'businessunit/view/:buId',
    component: BusinessUnitEditorComponent,
    data: <CrudEditConfig<BusinessUnit, string>>{
      parentMenuLink: '/admin',
      itemComponentType: BusinessUnitItemComponent,
      readOnly: true
    }
  },

  {
    path: 'businessunitaddress/search',
    component: BusinessUnitAddressSearchComponent,
    data: {
      parentMenuLink: '/admin'
    }
  },
  {
    path: 'businessunitaddress/create',
    component: BusinessUnitAddressEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<BusinessUnitAddress, number>>{
      parentMenuLink: '/admin',
      itemComponentType: BusinessUnitAddressItemComponent
    }
  },
  {
    path: 'businessunitaddress/edit/:businessUnitAddressId',
    component: BusinessUnitAddressEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<BusinessUnitAddress, number>>{
      parentMenuLink: '/admin',
      itemComponentType: BusinessUnitAddressItemComponent
    }
  },
  {
    path: 'businessunitaddress/view/:businessUnitAddressId',
    component: BusinessUnitAddressEditorComponent,
    data: <CrudEditConfig<BusinessUnitAddress, number>>{
      parentMenuLink: '/admin',
      itemComponentType: BusinessUnitAddressItemComponent,
      readOnly: true
    }
  },

  {
    path: 'businessunitemailcontact/search',
    component: BusinessUnitEmailContactSearchComponent,
    data: {
      parentMenuLink: '/admin'
    }
  },
  {
    path: 'businessunitemailcontact/create',
    component: BusinessUnitEmailContactEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<BusinessUnitEmailContact, number>>{
      parentMenuLink: '/admin',
      itemComponentType: BusinessUnitEmailContactItemComponent
    }
  },
  {
    path: 'businessunitemailcontact/edit/:businessUnitEmailContactId',
    component: BusinessUnitEmailContactEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<BusinessUnitEmailContact, number>>{
      parentMenuLink: '/admin',
      itemComponentType: BusinessUnitEmailContactItemComponent
    }
  },
  {
    path: 'businessunitemailcontact/view/:businessUnitEmailContactId',
    component: BusinessUnitEmailContactEditorComponent,
    data: <CrudEditConfig<BusinessUnitEmailContact, number>>{
      parentMenuLink: '/admin',
      itemComponentType: BusinessUnitEmailContactItemComponent,
      readOnly: true
    }
  },

  // routes for CostCentre

  {
    path: 'costcentre/search',
    component: CostCentreSearchComponent,
    data: {
      parentMenuLink: '/parentTopLevelMenu'
    }
  },
  {
    path: 'costcentre/create',
    component: CostCentreEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<CostCentre, string>>{
      parentMenuLink: '/parentTopLevelMenu',
      itemComponentType: CostCentreItemComponent
    }
  },
  {
    path: 'costcentre/edit/:ccId',
    component: CostCentreEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<CostCentre, string>>{
      parentMenuLink: '/parentTopLevelMenu',
      itemComponentType: CostCentreItemComponent
    }
  },
  {
    path: 'costcentre/view/:ccId',
    component: CostCentreEditorComponent,
    data: <CrudEditConfig<CostCentre, string>>{
      parentMenuLink: '/parentTopLevelMenu',
      itemComponentType: CostCentreItemComponent,
      readOnly: true
    }
  },

  // Asset/Firearm routes:
  {
    path: 'asset/upload',
    component: AssetDataUploadComponent,
    data: {
      parentMenuLink: '/admin'
    }
  },


  {
    path: 'asset/search',
    component: AssetSearchComponent,
    data: {
      parentMenuLink: '/assets'
    }
  },
  {
    path: 'asset/create',
    component: AssetEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<Asset, number>>{
      parentMenuLink: '/assets',
      itemComponentType: AssetItemComponent
    }
  },
  {
    path: 'asset/edit/:assetId',
    component: AssetEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<Asset, number>>{
      parentMenuLink: '/assets',
      itemComponentType: AssetItemComponent
    }
  },
  {
    path: 'asset/view/:assetId',
    component: AssetEditorComponent,
    data: <CrudEditConfig<Asset, number>>{
      parentMenuLink: '/assets',
      itemComponentType: AssetItemComponent,
      readOnly: true
    }
  },
  {
    path: 'asset/audit/:assetId',
    component: AssetAuditListComponent,
    data: {
      parentMenuLink: '/assets'
    }
  },
  {
    path: 'assettype/search',
    component: AssetTypeSearchComponent,
    data: {
      parentMenuLink: '/assets'
    }
  },
  {
    path: 'assettype/create',
    component: AssetTypeEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<AssetType, number>>{
      parentMenuLink: '/assets',
      itemComponentType: AssetTypeItemComponent
    }
  },
  {
    path: 'assettype/edit/:assetTypeId',
    component: AssetTypeEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<AssetType, number>>{
      parentMenuLink: '/assets',
      itemComponentType: AssetTypeItemComponent
    }
  },
  {
    path: 'assettype/view/:assetTypeId',
    component: AssetTypeEditorComponent,
    data: <CrudEditConfig<AssetType, number>>{
      parentMenuLink: '/assets',
      itemComponentType: AssetTypeItemComponent,
      readOnly: true
    }
  },
  {
    path: 'transferasset/edit/:transferAssetId',
    component: TransferAssetEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<TransferAsset, number>>{
      parentMenuLink: '/assets',
      itemComponentType: TransferAssetItemComponent
    }
  },
  {
    path: 'transferasset/view/:transferAssetId',
    component: TransferAssetEditorComponent,
    data: <CrudEditConfig<TransferAsset, number>>{
      parentMenuLink: '/assets',
      itemComponentType: TransferAssetItemComponent,
      readOnly: true
    }
  },
  {
    path: 'assetmaintenance/search/:assetId/:composedAssetClass',
    component: AssetMaintenanceSearchComponent,
    data: {
      parentMenuLink: '/assets'
    }
  },
  {
    path: 'assetmaintenance/create/:assetId/:composedAssetClass',
    component: AssetMaintenanceEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<AssetMaintenance, number>>{
      parentMenuLink: '/assets',
      itemComponentType: AssetMaintenanceItemComponent
    }
  },
  {
    path: 'assetmaintenance/edit/:assetMaintenanceId/:composedAssetClass',
    component: AssetMaintenanceEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<AssetMaintenance, number>>{
      parentMenuLink: '/assets',
      itemComponentType: AssetMaintenanceItemComponent
    }
  },
  {
    path: 'assetmaintenance/view/:assetMaintenanceId/:composedAssetClass',
    component: AssetMaintenanceEditorComponent,
    data: <CrudEditConfig<AssetMaintenance, number>>{
      parentMenuLink: '/assets',
      itemComponentType: AssetMaintenanceItemComponent,
      readOnly: true
    }
  },
  {
    path: 'firearm/upload',
    component: FirearmDataUploadComponent,
    data: {
      parentMenuLink: '/admin'
    }
  },
  {
    path: 'firearm/search',
    component: FirearmSearchComponent,
    data: {
      parentMenuLink: '/firearms'
    }
  },
  {
    path: 'firearm/create',
    component: FirearmEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<Firearm, number>>{
      parentMenuLink: '/firearms',
      itemComponentType: FirearmItemComponent
    }
  },
  {
    path: 'firearm/edit/:assetId',
    component: FirearmEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<Firearm, number>>{
      parentMenuLink: '/firearms',
      itemComponentType: FirearmItemComponent
    }
  },
  {
    path: 'firearm/view/:assetId',
    component: FirearmEditorComponent,
    data: <CrudEditConfig<Firearm, number>>{
      parentMenuLink: '/firearms',
      itemComponentType: FirearmItemComponent,
      readOnly: true
    }
  },
  {
    path: 'firearm/audit/:assetId',
    component: FirearmAuditListComponent,
    data: {
      parentMenuLink: '/firearms'
    }
  },
  {
    path: 'firearmpool/search',
    component: FirearmPoolSearchComponent,
    data: {
      parentMenuLink: '/firearms'
    }
  },
  {
    path: 'firearmpool/create',
    component: FirearmPoolEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<FirearmPool, number>>{
      parentMenuLink: '/firearms',
      itemComponentType: FirearmPoolItemComponent
    }
  },
  {
    path: 'firearmpool/create/:assetId',
    component: FirearmPoolEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<FirearmPool, number>>{
      parentMenuLink: '/firearms',
      itemComponentType: FirearmPoolItemComponent
    }
  },
  {
    path: 'firearmpool/edit/:firearmAssetId',
    component: FirearmPoolEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<FirearmPool, number>>{
      parentMenuLink: '/firearms',
      itemComponentType: FirearmPoolItemComponent
    }
  },
  {
    path: 'firearmpool/view/:firearmAssetId',
    component: FirearmPoolEditorComponent,
    data: <CrudEditConfig<FirearmPool, number>>{
      parentMenuLink: '/firearms',
      itemComponentType: FirearmPoolItemComponent,
      readOnly: true
    }
  },
  {
    path: 'firearmstoragelocationpli/search/:firearmStorageLocationId',
    component: FirearmStorageLocationPLISearchComponent,
    resolve: { storageLocation: FirearmStorageLocationResolver },
    data: { parentMenuLink: '/firearms' }
  },
  {
    path: 'firearmstoragelocationpli/create/:firearmStorageLocationId',
    component: FirearmStorageLocationPLIEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    resolve: { storageLocation: FirearmStorageLocationResolver },
    data: <CrudEditConfig<FirearmStorageLocationPLI, number>>{
      parentMenuLink: '/firearms', itemComponentType: FirearmStorageLocationPLIItemComponent
    }
  },
  {
    path: 'firearmstoragelocationpli/edit/:firearmStorageLocationPLIId',
    component: FirearmStorageLocationPLIEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<FirearmStorageLocationPLI, number>>{
      parentMenuLink: '/firearms', itemComponentType: FirearmStorageLocationPLIItemComponent
    }
  },
  {
    path: 'firearmstoragelocationpli/view/:firearmStorageLocationPLIId',
    component: FirearmStorageLocationPLIEditorComponent,
    data: <CrudEditConfig<FirearmStorageLocationPLI, number>>{
      parentMenuLink: '/firearms', itemComponentType: FirearmStorageLocationPLIItemComponent, readOnly: true
    }
  },
  {
    path: 'firearmstoragelocation/search',
    component: FirearmStorageLocationSearchComponent,
    data: {
      parentMenuLink: '/firearms'
    }
  },
  {
    path: 'firearmstoragelocation/create',
    component: FirearmStorageLocationEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<FirearmStorageLocation, number>>{
      parentMenuLink: '/firearms',
      itemComponentType: FirearmStorageLocationItemComponent
    }
  },
  {
    path: 'firearmstoragelocation/edit/:firearmStorageLocationId',
    component: FirearmStorageLocationEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<FirearmStorageLocation, number>>{
      parentMenuLink: '/firearms',
      itemComponentType: FirearmStorageLocationItemComponent
    }
  },
  {
    path: 'firearmstoragelocation/view/:firearmStorageLocationId',
    component: FirearmStorageLocationEditorComponent,
    data: <CrudEditConfig<FirearmStorageLocation, number>>{
      parentMenuLink: '/firearms',
      itemComponentType: FirearmStorageLocationItemComponent,
      readOnly: true
    }
  },
  {
    path: 'firearmsassignment/acknowledge-assignment',
    component: RangerAcknowledgeAssignmentComponent,
    data: {
      parentMenuLink: '/firearms'
    }
  },
  {
    path: 'firearmassignment/search',
    component: FirearmAssignmentSearchComponent,
    data: {
      parentMenuLink: '/firearms'
    }
  },
  {
    path: 'firearmassignment/edit/:firearmAssignmentId',
    component: FirearmAssignmentEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<FirearmAssignment, number>>{
      parentMenuLink: '/firearms',
      itemComponentType: FirearmAssignmentItemComponent
    }
  },
  {
    path: 'firearmassignment/view/:firearmAssignmentId',
    component: FirearmAssignmentEditorComponent,
    data: <CrudEditConfig<FirearmAssignment, number>>{
      parentMenuLink: '/firearms',
      itemComponentType: FirearmAssignmentItemComponent,
      readOnly: true
    }
  },
  {
    path: 'rangerfirearmassignmentlog/edit/:rangerId',
    component: RangerFirearmAssignmentLogEditorComponent,
    data: <CrudEditConfig<RangerFirearmAssignmentLog, number>>{
      parentMenuLink: '/firearms',
      itemComponentType: RangerFirearmAssignmentLogItemComponent
    }
  },
  {
    path: 'rangerfirearmassignmentlog/view/:rangerId',
    component: RangerFirearmAssignmentLogEditorComponent,
    data: <CrudEditConfig<RangerFirearmAssignmentLog, number>>{
      parentMenuLink: '/firearms',
      itemComponentType: RangerFirearmAssignmentLogItemComponent,
      readOnly: true
    }
  },
  {
    path: 'firearmassignmentlog/edit/:assetId',
    component: FirearmAssignmentLogEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<FirearmAssignmentLog, number>>{
      parentMenuLink: '/firearms',
      itemComponentType: FirearmAssignmentLogItemComponent
    }
  },
  {
    path: 'firearmassignmentlog/view/:assetId',
    component: FirearmAssignmentLogEditorComponent,
    data: <CrudEditConfig<FirearmAssignmentLog, number>>{
      parentMenuLink: '/firearms',
      itemComponentType: FirearmAssignmentLogItemComponent,
      readOnly: true
    }
  },

  {
    path: 'ranger/search',
    component: RangerSearchComponent,
    data: {
      parentMenuLink: '/firearms'
    }
  },
  {
    path: 'ranger/create',
    component: RangerEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<Ranger, number>>{
      parentMenuLink: '/firearms',
      itemComponentType: RangerItemComponent
    }
  },
  {
    path: 'ranger/edit/:rangerId',
    component: RangerEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<Ranger, number>>{
      parentMenuLink: '/firearms',
      itemComponentType: RangerItemComponent
    }
  },
  {
    path: 'ranger/view/:rangerId',
    component: RangerEditorComponent,
    data: <CrudEditConfig<Ranger, number>>{
      parentMenuLink: '/firearms',
      itemComponentType: RangerItemComponent,
      readOnly: true
    }
  },
  {
    path: 'ammunitionstock/search',
    component: AmmunitionStockSearchComponent,
    data: {
      parentMenuLink: '/firearms'
    }
  },
  {
    path: 'ammunitionstock/create',
    component: AmmunitionStockEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<AmmunitionStock, number>>{
      parentMenuLink: '/firearms',
      itemComponentType: AmmunitionStockItemComponent
    }
  },
  {
    path: 'ammunitionstock/edit/:ammunitionStockId',
    component: AmmunitionStockEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<AmmunitionStock, number>>{
      parentMenuLink: '/firearms',
      itemComponentType: AmmunitionStockItemComponent
    }
  },
  {
    path: 'ammunitionstock/view/:ammunitionStockId',
    component: AmmunitionStockEditorComponent,
    data: <CrudEditConfig<AmmunitionStock, number>>{
      parentMenuLink: '/firearms',
      itemComponentType: AmmunitionStockItemComponent,
      readOnly: true
    }
  },
  {
    path: 'ammunitionstock/stocktake',
    component: AmmunitionStockEventRowsEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <AmmunitionStockEventRowsEditConfig>{
      parentMenuLink: '/firearms',
      rowsItemComponentType: AmmunitionStockEventRowsComponent,
      eventType: 'Stocktake'
    },
  },
  {
    path: 'ammunitionstock/issue',
    component: AmmunitionStockEventRowsEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <AmmunitionStockEventRowsEditConfig>{
      parentMenuLink: '/firearms',
      rowsItemComponentType: AmmunitionStockEventRowsComponent,
      eventType: 'Issue'
    },
  },

  {
    path: 'ammunitionstock/return',
    component: AmmunitionStockEventRowsEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <AmmunitionStockEventRowsEditConfig>{
      parentMenuLink: '/firearms',
      rowsItemComponentType: AmmunitionStockEventRowsComponent,
      eventType: 'Return'
    },
  },

  {
    path: 'ammunitionstock/additions',
    component: AmmunitionStockEventRowsEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <AmmunitionStockEventRowsEditConfig>{
      parentMenuLink: '/firearms',
      rowsItemComponentType: AmmunitionStockEventRowsComponent,
      eventType: 'Addition'
    },
  },
  {
    path: 'ammunitionstock/acknowledge-issue',
    component: AmmunitionAcknowledgeIssueReturnComponent,
    data: {
      eventType: 'Issue',
      parentMenuLink: '/firearms'
    }
  },
   {
    path: 'ammunitionstock/acknowledge-return',
    component: AmmunitionAcknowledgeIssueReturnComponent,
    data: {
      eventType: 'Return',
      parentMenuLink: '/firearms'
    }
  },
  {
    path: 'ammunitionstockevent/history/:ammunitionStockId',
    component: AmmunitionStockEventHistoryComponent,
    data: {
      parentMenuLink: '/firearms'
    }
  },

  {
    path: 'ammunitionstockevent/rangerhistory/:rangerId',
    component: AmmunitionStockEventHistoryComponent,
    data: {
      parentMenuLink: '/firearms'
    }
  },

  // end: Asset/Firearm experiments

  // {
  //   path: 'reportviewer',
  //   component: FullHTMLReportViewerComponent,
  //   data: {
  //     reportData: DEFAULT_CHART_REPORT_DATA
  //   }
  // },
  {
    path: 'role/search',
    component: RoleSearchComponent
  },
  {
    path: 'role/edit/:name',
    component: RoleEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<Role, string>>{
      parentMenuLink: '/admin',
      itemComponentType: RoleItemComponent
    }
  },
  {
    path: 'role/view/:name',
    component: RoleEditorComponent,
    data: <CrudEditConfig<Role, string>>{
      parentMenuLink: '/admin',
      itemComponentType: RoleItemComponent,
      readOnly: true
    }
  },
  {
    path: 'role/create',
    component: RoleEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<Role, string>>{
      parentMenuLink: '/admin',
      itemComponentType: RoleItemComponent
    }
  },
  {
    path: 'user/search',
    component: UserSearchComponent
  },
  {
    path: 'user/edit/:username',
    component: UserEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<User, string>>{
      parentMenuLink: '/admin',
      itemComponentType: UserItemComponent
    }
  },
  {
    path: 'user/view/:username',
    component: UserEditorComponent,
    data: <CrudEditConfig<User, string>>{
      parentMenuLink: '/admin',
      itemComponentType: UserItemComponent,
      readOnly: true
    }
  },
  {
    path: 'user/create',
    component: UserEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<User, string>>{
      parentMenuLink: '/admin',
      itemComponentType: UserItemComponent
    }
  },
  {
    path: 'assetsuserdetails/edit/:user',
    component: AssetsUserDetailsEditorComponent,
    canDeactivate: [CrudCanDeactivate],
    data: <CrudEditConfig<AssetsUserDetails, string>>{
      parentMenuLink: '/admin',
      itemComponentType: AssetsUserDetailsItemComponent
    }
  },
  {
    path: 'assetsuserdetails/view/:user',
    component: AssetsUserDetailsEditorComponent,
    data: <CrudEditConfig<AssetsUserDetails, string>>{
      parentMenuLink: '/admin',
      itemComponentType: AssetsUserDetailsItemComponent,
      readOnly: true
    }
  },
  // {
  //   path: 'automatedjobs',
  //   component: AutomatedJobRunComponent
  // },
  {
    path: 'internal-file/search',
    component: InternalFileSearchComponent,
    data: {
      parentMenuLink: '/admin'
    }
  },

];

export function assetsModuleRoots() {
  return RouterModule.forRoot(_moduleRootsVal, { onSameUrlNavigation: 'reload' });
}

@NgModule({
  imports: [assetsModuleRoots()],
  exports: [RouterModule]
})
export class AppRoutingModule { }
